<template>
	<v-container class="restore-password-page">
		<v-col md="5" offset-md="3" :class="{ 'margin-bottom': $vuetify.breakpoint.mdAndUp }">
			<h1 class="restore-password-page__title">
				Restore Password
			</h1>
			<p class="restore-password-page__description mt-2">
				The instructions will be sent to the specified email address
			</p>
			<RestorePasswordForm />
		</v-col>
	</v-container>
</template>
<script>
import RestorePasswordForm from '@/components/Forms/RestorePasswordForm'
import ButtonBack from '@/components/ButtonBack'

export default {
	components: {
		RestorePasswordForm,
		ButtonBack,
	},
}
</script>
<style lang="scss">
.restore-password-page {
	font-family: Montserrat, sans-serif;

	&__title {
		color: rgb(74, 74, 74);
		font-size: 33px;
		font-weight: bold;
	}

	&__description {
		font-size: 16px;
		color: #4A4A4A;
		line-height: 19.5px;
	}

	&__back-wrapper {
		margin-bottom: 100px;
		margin-left: 30px;

		@media (max-width: 959px) {
			margin-left: 0;
		}
	}
}
</style>